import { useState } from "react";
import apiClient from "../../../apiClient";
import { IFFM, SelectOption } from "../../../globals/interfaces";

export default function useMawbSummaryData () {
    const [mawbSummaryFFMs, setMawbSummaryFFMs] = useState([]);
    const [selectedShcs, setSelectedShcs] = useState<Array<SelectOption>>([]);

    const getMawbSummaryData = async (s_mawb: string, s_flight_id: string) => {
        try {
            const res = await apiClient.get(`/breakdownInstructionsMawbSummary?s_mawb=${s_mawb}&s_flight_id=${s_flight_id}`);
            const data: Array<IFFM> = res.data;
            setMawbSummaryFFMs(data);

            const shcsSet = new Set();
            for (const { s_special_handling_code } of data) {
                if (s_special_handling_code) {
                    const codes = s_special_handling_code.split(',');
                    codes.map(c => shcsSet.add(c));
                }
            }

            setSelectedShcs(Array.from(shcsSet).map((item: string) => ({
                label: item,
                value: item
            })));
        } catch (err) {
            alert(err);
        }
    }

    const breakdownInstructionsMawbSummaryUpdateShc = async () => {
        const ids: Array<string> = mawbSummaryFFMs.map(item => (item.id));
        const s_special_handling_code = selectedShcs.map(shc => (shc.value)).join(',');
        try {
            await apiClient.put(`/breakdownInstructionsMawbSummaryUpdateShc`, {
                ids,
                s_special_handling_code
            });
        } catch (err) {
            alert(err);
        }
    }

    return {
        mawbSummaryFFMs,
        selectedShcs,
        setSelectedShcs,
        getMawbSummaryData,
        breakdownInstructionsMawbSummaryUpdateShc
    }
}